import React from "react";
import styled from "styled-components";
import GraphIcon from "../../../../components/icons/GraphIcon";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import grey from "@material-ui/core/colors/grey";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Tabs from "../Tabs";

export const DropDownIcon = styled((props) => <KeyboardArrowDownIcon {...props}/>)`
  border: solid 1px ${grey[300]};
  border-radius: 3px;
  margin-left: 4px;
  cursor: pointer;
  &&& {
    font-size: 18px;
  }
`;

export const PopoverHeader = styled.div`
  color: #026d94;
  font-weight: 500;
  display: flex;
  align-items: center;
  margin-top: 25px;
  width: 300px;
`;

export const BenchmarkIcon = styled((props) => <GraphIcon {...props}/>)`
  margin-left: 25px;
  margin-right: 6px;
  margin-bottom: 0;
  &&& {
    font-size: 13px;
  }
`;

export const PopoverDescription = styled.div`
  margin-left: 24px;
  margin-top: 20px;
  margin-bottom: -4px;
  color: ${grey[700]};
`;

export const HorizontalLine = styled.div`
  border-bottom: solid 1px ${grey[300]};
`;

export const PopoverTabs = styled((props) => <Tabs {...props}/>)`
  margin-top: 16px;
`;

export const BenchmarkOptions = styled((props) => <RadioGroup {...props}/>)`
  padding: 8px 0;
`;

export const BenchmarkOption = styled((props) => <FormControlLabel {...props}/>)`
  padding-left: 23px;
  padding-right: 10px;
`;



// WEBPACK FOOTER //
// ./src/pages/MagnetReport/components/BenchmarkPopover/style.js